import React from 'react';
import { IconButton, Menu, MenuItem, Box, Button } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import { useNavigate, useLocation } from 'react-router-dom';
import { useFirebase } from '../contexts/FirebaseContext';
import ProfileImage from './ProfileImage';
import { useAuth } from '../contexts/AuthContext';

function NavMenu({ handleAvatarClick }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const { auth } = useFirebase();
  const { userProfile } = useAuth();

  const handleSignOut = async () => {
    try {
      await auth.signOut();
      navigate('/');
    } catch (error) {
      console.error('Error signing out:', error);
    }
  };

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (path) => {
    navigate(path);
    handleMenuClose();
  };

  const handleNewGame = () => {
    navigate('/new-game');
  };

  return (
    <>
      {userProfile && !userProfile?.phoneNumber && (
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Button
            variant="containedWagl"
            sx={{ width: 'unset', padding: '8px 24px', mr: 2, borderRadius: '100px' }}
            onClick={() => navigate('/settings#phone')}
          >
            Add your mobile number
          </Button>
        </Box>
      )}
      {location.pathname !== '/new-game' && userProfile && (
        <Box sx={{ display: { xs: 'none', md: 'block' } }}>
          <Button
            variant="containedWagl"
            sx={{ width: 'unset', padding: '8px 24px', mr: 2, borderRadius: '100px' }}
            onClick={handleNewGame}
            startIcon={<AddCircleOutlineIcon />}
          >
            Start a Game
          </Button>
        </Box>
      )}
      <Box sx={{ display: 'flex' }}>
        <ProfileImage size="32" onClick={handleAvatarClick} />
      </Box>
      <IconButton
        onClick={handleMenuOpen}
        color="inherit"
        edge="end"
        aria-label="menu"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MenuIcon />
      </IconButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleMenuClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem onClick={() => handleMenuItemClick('/dashboard')}>Dashboard</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/activity')}>Activity</MenuItem>
        <MenuItem onClick={() => handleMenuItemClick('/settings')}>Settings</MenuItem>
        <MenuItem
          onClick={() => {
            handleSignOut();
            handleMenuClose();
          }}
          sx={{ color: 'error.main' }}
        >
          Sign Out
        </MenuItem>
      </Menu>
    </>
  );
}

export default NavMenu;
